export default __webpack_public_path__ + "static/media/athlete.3c63e0a2.png";